import React from "react";
import { MuiTelInputProps, MuiTelInput } from "mui-tel-input";
import { CoreFormControl, CoreFormControlProps } from "../core-form-control";

export type CorePhoneInputProps = CoreFormControlProps & MuiTelInputProps;

export function CorePhoneInput(props: CorePhoneInputProps) {
	const {
		id,
		fullWidth,
		controlSx,
		label,
		labelSx,
		helperText,
		error,
		disabled,
		focused,
		requiredMark,
		controlId,
		sx,
		...inputProps
	} = props;

	return (
		<CoreFormControl
			disabled={disabled}
			error={error}
			helperText={helperText}
			label={label}
			id={id}
			labelSx={labelSx}
			requiredMark={requiredMark}
			focused={focused}
			fullWidth={fullWidth}
			controlSx={controlSx}
			controlId={controlId}
		>
			<MuiTelInput
				{...inputProps}
				error={error}
				disabled={disabled}
				id={id}
				sx={[
					{
						'& .MuiInputBase-root': {
							backgroundColor: '#FFFFFF0D',
							color: '#FFFFFF',
							borderRadius: '12px',

							'& .MuiInputBase-input': {
								height: 'auto',
								p: '13px 16px',
								fontFamily: 'Montserrat',
								fontSize: '16px',
								fontWeight: 500,
								lineHeight: '20px',

								'&::placeholder': {
									color: '#FFFFFF',
									opacity: 0.3,
								},

								'&.Mui-disabled': {
									WebkitTextFillColor: 'unset',
									color: 'rgba(255, 255, 255, 0.6)'
								},
							},

							'& .MuiInputAdornment-root ': {
								'& .MuiTelInput-FlagImg': {
									borderRadius: '2px',
								},

								'& .MuiTypography-root': {
									color: 'rgba(255, 255, 255, 0.6)',
									borderColor: 'rgba(255, 255, 255, 0.2)'
								}
							},

							'& .MuiInputBase-inputAdornedStart': {
								paddingLeft: 0,
							},

							'&.MuiOutlinedInput-root': {
								'&:hover .MuiOutlinedInput-notchedOutline': {
									borderWidth: '1px',
									borderColor: '#FFFFFF0D',
								},

								'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
									borderWidth: '1px',
									borderColor: '#FFFFFF99',
								},

								'&.Mui-error .MuiOutlinedInput-notchedOutline': {
									borderWidth: '1px',
									borderColor: '#FF563F',
								}
							},
						},

						'& .MuiOutlinedInput-notchedOutline': {
							borderWidth: 0,
							borderRadius: '12px',
						},
					},
					...(Array.isArray(sx) ? sx : [sx]),
				]}
			/>
		</CoreFormControl>
	);
}
